import { render } from "./TextView.vue?vue&type=template&id=f23dc910"
import script from "./TextView.vue?vue&type=script&lang=js"
export * from "./TextView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__